import React from "react";
import { FAQCont1, FAQText, FAQtg, FAQTitle } from "./styles";

export const FAQ = () => {
  return (
    <FAQCont1>
      <FAQTitle>FAQ</FAQTitle>
      <FAQText>
        Что-то еще ? Напишите нам в{" "}
        <FAQtg href="https://t.me/ProhorovaConsult">Telegram</FAQtg>
      </FAQText>
    </FAQCont1>
  );
};
